<template>
  <v-container>
    <TitleChip title="Trocar Loja/Usuário" />
    <div class="animated fadeInLeft delay-1s positionBrand">
      <h4>Defina qual marca deseja acessar</h4>
      <v-autocomplete
        class="select my-2"
        data-cy="select-input"
        :items="customers"
        item-text="name"
        v-model="customer"
        return-object
        label="Selecione a Marca"
        persistent-hint
      >
      </v-autocomplete>
    </div>

    <div class="animated fadeInLeft delay-1s positionSeller">
      <h4>Defina qual loja deseja acessar</h4>
      <v-autocomplete
        class="select my-2"
        data-cy="select-input"
        :items="stores"
        item-text="name"
        v-model="store"
        return-object
        label="Selecione a Loja"
        persistent-hint
      >
      </v-autocomplete>
    </div>

    <div class="animated fadeInLeft delay-1s positionSeller">
      <h4>Defina qual vendedor deseja acessar</h4>
      <v-autocomplete
        class="select my-2"
        data-cy="select-input"
        :items="sellers"
        item-text="name"
        v-model="seller"
        return-object
        label="Selecione o Vendedor"
        persistent-hint
      >
      <template v-slot:selection="{ item }">
        {{ item.name | startCase }}
      </template>
      <template v-slot:item="{ item }">
        {{ item.name | startCase }} {{ item.manager || item.director ? "(GERENCIAL)": " "}}
        </template>
      </v-autocomplete>


      <v-btn
        type="submit"
        color="primary"
        class="animated fadeInLeft delay-1s positionButton login-btn"
        style="margin-bottom: 100px"
        @click="login()"
      >
        <span>Entrar</span>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { Auth0UserById } from '@/apollo';
import capitalize from 'lodash.capitalize';
import { APIService } from '../resources/campanha.js';

const api = new APIService();

export default {
  filters: {
    startCase(str) {
      return str.replace(/\S+/g, capitalize);
    },
  },
  methods: {
    async login() {
      if (this.customer && !this.store && !this.seller) {
      } else if (this.seller) {
        const res = await this.$apollo.query({
          query: Auth0UserById,
          variables: {
            id: this.seller._id,
          },
          fetchPolicy: 'no-cache',
        });
        const user = res.data.auth0UserById;
        if (!this.$auth.user.rootSub) { this.$auth.user.rootSub = this.$auth.user.sub; }
        this.$auth.user.sub = user.id;
        this.$auth.user.secondPicture = user.picture;
        localStorage.setItem('user', JSON.stringify(this.$auth.user));
        this.customer.stores.forEach((s) => {
          s.id = s._id;
          s.sellers.forEach((seller) => {
            seller.id = seller._id;
          });
        });
        this.$store.commit('SET_STORE', this.store);
        this.$store.dispatch('carregarPerfil', { user: this.$auth.user, customer: this.customer });
        this.$store.dispatch('carregarListaContatos', { user: this.$auth.user, force: true });
        this.$router.push('/');
      }
    },
  },
  data() {
    return {
      customer: {},
      sellers: [],
      seller: {},
      store: {},
      stores: [],
    };
  },
  watch: {
    async customer() {
      this.stores = [];
      if (this.customer) {
        this.stores = this.customer.stores.filter(s => !s.disabled );
      }
    },
    async store() {
      this.sellers = [];
      if (this.store) {
        this.sellers.push(...this.store.sellers.filter(seller => !seller.disabled));
      }
    },
  },
  computed: {
    customers() {
      return this.$store.state.customers;
    },
  },
};
</script>

<style scoped>
.positionBrand {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
}

.positionSeller {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.select {
  width: 250px;
}

.positionButton {
  margin-top: 40px;
  width: 250px;
}

.login-btn{
  border-radius: 7.08982px;
}
</style>
